import React, { useState, useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Alert, Button, CircularProgress } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getUserProfile, getPetInfobyTagId, getTagInfo } from "../services/api";
import Cookies from "js-cookie";
import { useTranslation } from 'react-i18next';

export async function handlePetTagNavigation(userId, tagId, navigate, setButtonLoading, setInputError, showLoginButton, showAddButton, t) {
  if (userId) {
    try {
      const userProfile = await getUserProfile(userId);
      const userRole = userProfile.data?.data?.role;
      if (userRole === "admin") {
        try {
          navigate(`/qr_verification?qr=${tagId}`);
        } catch {
          showLoginButton(false);
          setInputError(t('InputError'));
          setButtonLoading(false);
          showAddButton(false);
        }
      }
      else {
        try {
          const tagInfo = await getTagInfo(tagId);
          const isStaffVerified = tagInfo.data?.data?.staffVerification;
          if (isStaffVerified) {
            try {
              const petInfo = await getPetInfobyTagId(tagId);
              if (petInfo.status === 200) {
                if (petInfo.data.data.ownerEmail && (petInfo.data?.data?.ownerEmail !== userProfile.data?.data?.email)) {
                  console.log("Owner Email:", petInfo.data.data.ownerEmail);
                  navigate(`/Geolocation?qr=${tagId}&name=${petInfo.data?.data?.name}&email=${petInfo.data?.data?.ownerEmail}`);
                }
                else {
                  navigate(`/Geolocation?qr=${tagId}`);
                }
              }
            } catch (error) {
              if (error.status === 404) {
                setInputError(t('ErrorAdd'));
                showAddButton(true);
                setButtonLoading(false);
              }
            }
          } else {
            showLoginButton(false);
            showAddButton(false);
            setInputError(t('InputError'));
            setButtonLoading(false);
          }
        } catch (error) {
          showLoginButton(false);
          setInputError(t('InputError'));
          setButtonLoading(false);
          showAddButton(false);
        }
      }
    } catch (error) {
      showLoginButton(false);
      setInputError(t('InputError'));
      setButtonLoading(false);
      showAddButton(false);
    }
  } else {
    try {
      const tagInfo = await getTagInfo(tagId);
      const isStaffVerified = tagInfo.data.data.staffVerification;
      if (isStaffVerified) {
        try {
          const petInfo = await getPetInfobyTagId(tagId);
          if (petInfo.status === 200) {
            if (petInfo.data?.data?.ownerEmail) {
              navigate(`/Geolocation?qr=${tagId}&name=${petInfo.data?.data?.name}&email=${petInfo.data?.data?.ownerEmail}`);
            }
            else {
              navigate(`/Geolocation?qr=${tagId}`);
            }
          }
        } catch (error) {
          if (error.status === 404) {
            showLoginButton(true);
            setButtonLoading(false);
            showAddButton(false);
            setInputError(t('ErrorLogin&Add'));
            // navigate(`/login?qr=${tagId}`);
          }
        }
      } else {
        showLoginButton(false);
        setInputError(t('InputError'));
        setButtonLoading(false);
        showAddButton(false);
      }
    } catch (error) {
      showLoginButton(false);
      setInputError(t('InputError'));
      setButtonLoading(false);
      showAddButton(false);
    }
  }
}

const Landing = () => {
  const [petTagNumber, setPetTagNumber] = useState("");
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const [showHelpImage, setShowHelpImage] = useState(false); // 控制帮助图片的显示
  const helpImageRef = useRef(null); // 用于检测点击外部区域
  const formRef = useRef(null); // 用于表单提交引用
  const [buttonLoading, setButtonLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tagId = searchParams.get('qr') || '';
  const [inputError, setInputError] = useState("");
  const [LoginButton, showLoginButton] = useState(false);
  const [AddButton, showAddButton] = useState(false);

  // Get token from cookies
  const getUserId = () => {
    const id = Cookies.get("id");
    return id;
  };

  const userId = getUserId();

  // After scanning a Qrcode, check for tagId in URL and handle navigation
  useEffect(() => {
    if (tagId) {
      setButtonLoading(true);
      handlePetTagNavigation(userId, tagId, navigate, setButtonLoading, setInputError, showLoginButton, showAddButton, t);
    }
  }, [tagId, userId, navigate, t]);

  useEffect(() => {
    if (inputError) {
      if (inputError === t('ErrorAdd', { lng: 'zh' })) {
        setInputError(t('ErrorAdd'));
      }
      if (inputError === t('ErrorLogin&Add', { lng: 'zh' })) {
        setInputError(t('ErrorLogin&Add'));
      }
      if (inputError === t('InputError', { lng: 'zh' })) {
        setInputError(t('InputError'));
      }
      if (inputError === t('EmptyInputError', { lng: 'zh' })) {
        setInputError(t('EmptyInputError'));
      }

      if (inputError === t('ErrorAdd', { lng: 'en' })) {
        setInputError(t('ErrorAdd'));
      }
      if (inputError === t('ErrorLogin&Add', { lng: 'en' })) {
        setInputError(t('ErrorLogin&Add'));
      }
      if (inputError === t('InputError', { lng: 'en' })) {
        setInputError(t('InputError'));
      }
      if (inputError === t('EmptyInputError', { lng: 'en' })) {
        setInputError(t('EmptyInputError'));
      }
    }
  }, [t, inputError]);

  // 监听窗口大小变化
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 添加点击外部关闭图片的逻辑
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        helpImageRef.current &&
        !helpImageRef.current.contains(event.target)
      ) {
        setShowHelpImage(false);
      }
    };

    // 只有当图片显示时才添加事件监听
    if (showHelpImage) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showHelpImage]);

  //scrolled to top
  useEffect(() => {
    if (!tagId) {
      window.scrollTo(0, 0);
    }
  }, [tagId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!petTagNumber.trim()) {
      showAddButton(false);
      showLoginButton(false);
      setInputError(t('EmptyInputError'));
      return;
    }
    setButtonLoading(true);

    const tagId = petTagNumber.trim().toUpperCase();
    await handlePetTagNavigation(userId, tagId, navigate, setButtonLoading, setInputError, showLoginButton, showAddButton, t);
  };

  // 处理图标点击
  const handleInfoClick = (e) => {
    e.stopPropagation(); // 阻止事件冒泡
    setShowHelpImage(!showHelpImage);
  };

  // 响应式布局断点
  const isMobile = windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;

  // 普通版
  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    overflowX: "hidden", 
  };

  const ContainerStyle = {
    width: "100vw",
    height: isMobile ? "calc(100vh - 70px)" : "calc(100vh - 70px)",
    position: "relative",
    overflow: "hidden",
    paddingTop: "70px",
    marginLeft: "0",
    marginRight: "0",
    boxSizing: "border-box",
  };

  const dogImageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: isMobile ? "75% center" : "center center",
    display: "block",
    transition: "transform 0.2s linear",
    willChange: "transform",
  };

  const formContainerStyle = {
    position: "absolute",
    top: isMobile ? "50%" : "50%",
    left: isMobile ? "50%" : isTablet ? "25%" : "4.5%",
    transform: isMobile ? "translate(-50%, -50%)" : "translateY(-50%)",
    width: isMobile ? "85%" : isTablet ? "450px" : "449px",
    height: "auto",
    padding: isMobile ? "25px 20px" : "20px",
    zIndex: 10,
    backgroundColor: isMobile ? "#FCF8F3CC" : "transparent", // 移动端添加半透明背景
    borderRadius: isMobile ? "10px" : "0",
    boxShadow: isMobile ? "0 2px 10px rgba(0,0,0,0.1)" : "none",
  };

  const formHeaderStyle = {
    fontSize: isMobile ? "26px" : "var(--font-subtitle-desktop)",
    color: "var(--color-black)",
    marginBottom: isMobile ? "20px" : "30px",
    textAlign: isMobile ? "center" : "left",
    fontWeight: "bold",
  };

  const formGroupStyle = {
    position: "relative", // 为帮助图片定位
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  };

  // 标签容器样式，用于将标签和图标并排放置
  const labelContainerStyle = {
    display: "flex",
    alignItems: "center",
  };

  // 标签文本样式
  const labelTextStyle = {
    fontSize: isMobile ? "13px" : "var(--font-size-lg)",
    color: "var(--color-black)",
    lineHeight: "24px",
    margin: 0,
  };

  // 图标样式
  const iconStyle = {
    width: "20px",
    height: "20px",
    marginLeft: "8px",
    cursor: "pointer",
    verticalAlign: "middle",
  };

  // 帮助图片样式
  const helpImageStyle = {
    position: "absolute",
    top: isMobile ? "-115px" : "-170px", // 将图片移动到上方
    left: "60%", // 水平居中
    transform: "translateX(-50%)", // 确保居中对齐
    maxWidth: "300px", // 根据实际图片调整宽度
    boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
    zIndex: 100,
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: "#fff",
    padding: "5px",
    display: showHelpImage ? "block" : "none",
  };

  const inputStyle = {
    width: "100%",
    padding: isMobile ? "12px" : "12px",
    border: "1px solid #ddd",
    borderRadius: "3px",
    fontSize: isMobile ? "12px" : "var(--font-size-lg)",
    boxSizing: "border-box",
    textTransform: "uppercase", // 添加大写转换，与原HTML一致
    backgroundColor: "white",
  };

  const buttonContainerStyle = {
    marginTop: 10,
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: "10px",
  };

  const primaryButtonStyle = {
    backgroundColor: "var(--color-button-primary)",
    color: "var(--color-black)",
    border: "none",
    padding: "14px 23px",
    fontSize: "var(--font-size-base)",
    fontWeight: "bold",
    borderRadius: "3px",
    cursor: "pointer",
    width: isMobile ? "100%" : "auto",
  };

  const linkStyle = {
    display: "block",
    marginTop: isMobile ? "20px" : "20px", // 移动端和桌面端的上边距
    marginBottom: isMobile ? "15px" : "0", // 移动端添加下边距
    color: "var(--color-primary)",
    fontSize: "var(--font-size-xs)",
    textDecoration: "underline",
    textAlign: isMobile ? "center" : "left",
  };

  return (
    <div style={pageStyle}>
      <Navbar />
      <section style={ContainerStyle}>
        <img
          src="/atlas/tagId.png"
          alt="登记你的tagId"
          style={dogImageStyle}
          loading="eager"
        />

            <div style={formContainerStyle}>
              <h1 style={formHeaderStyle}>
                {t('checkPetTags3')}
              </h1>

              <form
                ref={formRef}
                // action="https://www.ptag.com.hk/php/ptagair_active.php"
                // method="POST"
                autoComplete="on"
              >
                <div style={formGroupStyle}>
                  <div style={labelContainerStyle}>
                    <label style={labelTextStyle} htmlFor="petTag">
                      {t('PetID')}
                    </label>
                    {/* <img
                      src="/icons/number.png"
                      alt="更多信息"
                      style={iconStyle}
                      onClick={handleInfoClick}
                      title="点击查看帮助图片"
                    /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" style={iconStyle} onClick={handleInfoClick} title="点击查看帮助图片" fill="none">
                      <path d="M9.9974 18.8307C14.5998 18.8307 18.3307 15.0998 18.3307 10.4974C18.3307 5.89502 14.5998 2.16406 9.9974 2.16406C5.39502 2.16406 1.66406 5.89502 1.66406 10.4974C1.66406 15.0998 5.39502 18.8307 9.9974 18.8307Z" stroke="#969696" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M7.57812 7.99852C7.77405 7.44158 8.16075 6.97194 8.66975 6.6728C9.17876 6.37365 9.7772 6.2643 10.3591 6.36411C10.941 6.46393 11.4688 6.76646 11.849 7.21813C12.2292 7.6698 12.4373 8.24146 12.4365 8.83185C12.4365 10.4985 9.93646 11.3319 9.93646 11.3319" stroke="#969696" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M10 14.6641H10.0083" stroke="#969696" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                    {/* 帮助图片，点击感叹号时显示 */}
                    {showHelpImage && (
                      <div ref={helpImageRef} style={helpImageStyle}>
                        <img
                          // src="/icons/qrCode.png"
                          src="/icons/numberPosition.png"
                          alt="宠物牌号码位置示例"
                          style={{ width: "100%" }}
                        />
                      </div>
                    )}
                  </div>
                  <input
                    style={inputStyle}
                    type="text"
                    placeholder={t('PetID')}
                    value={petTagNumber}
                    onChange={(e) => {
                      setPetTagNumber(e.target.value);
                      if (inputError) setInputError("");
                    }}
                    maxLength="10"
                    required
                  />

                  {inputError && (
                    <>
                      <Alert
                        severity="error"
                        sx={{
                          backgroundColor: "rgba(211, 47, 47, 0.1)", // optional: light red background
                        }}
                      >
                        {inputError}
                        {LoginButton && (
                          <Button
                            style={{
                              backgroundColor: "var(--color-button-primary)",
                              color: "var(--color-black)",
                              fontWeight: "bold",
                              fontSize: 10,
                              padding: "2px 8px",
                              marginLeft: "5px",
                              minWidth: 0,
                            }}
                            onClick={() => navigate(`/login?qr=${petTagNumber.trim().toUpperCase() || tagId}`)}
                          >
                            {t('loginFooter')}
                          </Button>
                        )}
                        {AddButton && (
                          <Button
                            style={{
                              backgroundColor: "var(--color-button-primary)",
                              color: "var(--color-black)",
                              fontWeight: "bold",
                              fontSize: 10,
                              padding: "2px 8px",
                              marginLeft: "5px",
                              minWidth: 0,
                            }}
                            onClick={() => navigate(`/pet-management?qr=${petTagNumber.trim().toUpperCase() || tagId}`)}
                          >
                            {t('Add')}
                          </Button>
                        )}
                      </Alert>
                    </>
                  )}

                  <div style={buttonContainerStyle}>
                    <button
                      style={{
                        ...primaryButtonStyle,
                        backgroundColor: buttonLoading
                          ? "rgba(255, 182, 12, 0.5)" // light color when loading
                          : "var(--color-button-primary)",
                        color: buttonLoading ? "#aaa" : "var(--color-black)",
                        cursor: buttonLoading ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                      type="submit"
                      onClick={handleSubmit}
                      disabled={buttonLoading}
                    >
                      {t('Confirm')}
                      {buttonLoading && (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                          }}
                        >
                          <CircularProgress size={20} color="inherit" />
                          {/* <Box component="img" src="/icons/loadingButton.gif" alt="Loading" sx={{ width: "40px", height: "auto", mixBlendMode: "multiply", }} /> */}
                        </span>
                      )}
                    </button>
                  </div>
                </div>

                {/* 移动端在按钮上方显示链接 */}
                {isMobile && (
                  <div style={{ textAlign: "center" }}>
                    <a
                      // href="../downloads/PTag寵物牌使用手冊_v2.1.pdf"
                      href="https://www.ptag.com.hk/downloads/PTagAirActivationGuide.mp4"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={linkStyle}
                    >
                      PTag寵物牌使用手冊
                    </a>
                  </div>
                )}


                {/* 桌面端在按钮下方显示链接 */}
                {/* {!isMobile && (
                  <a
                    href="../downloads/PTag寵物牌使用手冊_v2.1.pdf"
                    target="_blank"
                    style={linkStyle}
                  >
                    PTag寵物牌使用手冊
                  </a>
                )} */}
              </form>
            </div>
          </section>
      <Footer />
    </div>
  );
};

export default Landing;
